import {Directive, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges} from '@angular/core';
import tippy, {Content, Instance, Props} from 'tippy.js';

tippy.setDefaultProps({
	ignoreAttributes: true,
	arrow: false,
	maxWidth: '300px',
	trigger: 'mouseenter',
	zIndex: 99999,
} as Partial<Props>);

@Directive({selector: '[fang-popover]'})
export class FangPopoverDirective implements OnChanges, OnDestroy {
	@Input('fang-popover') options: Partial<Props>;
	@Input('content') content: Content;
	public instance: Instance;

	constructor(private el: ElementRef) {
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes['options']) {
			if (this.options && !this.instance) {
				this.instance = tippy(this.el.nativeElement, this.options) as any;
			} else if (this.options && this.instance) {
				this.instance.setProps(this.options);
			} else if ((!this.options || !this.options.content) && this.instance) {
				this.instance.destroy();
				this.instance = undefined;
			}
		}

		if (changes['content'] && this.instance) {
			this.instance.setContent(this.content);
		}
	}

	ngOnDestroy() {
		this.instance && this.instance.destroy();
	}
}
